import { render, staticRenderFns } from "./EditRemarkDialog.vue?vue&type=template&id=9f2882c6&scoped=true"
import script from "./EditRemarkDialog.vue?vue&type=script&lang=js"
export * from "./EditRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./EditRemarkDialog.vue?vue&type=style&index=0&id=9f2882c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2882c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f2882c6')) {
      api.createRecord('9f2882c6', component.options)
    } else {
      api.reload('9f2882c6', component.options)
    }
    module.hot.accept("./EditRemarkDialog.vue?vue&type=template&id=9f2882c6&scoped=true", function () {
      api.rerender('9f2882c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/EditRemarkDialog.vue"
export default component.exports